import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import privacyUrl from "../../assets/legal/privacy.md";

export default function PrivacyPolicy() {
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    fetch(privacyUrl)
      .then((res) => res.text())
      .then(setMarkdown);
  }, []);

  return (
    <div
      style={{
        padding: "2rem",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: 1.6,
        color: "black",
        fontFamily: "Arial, sans-serif",
        textTransform: "none",
      }}
    >
      <ReactMarkdown>{markdown}</ReactMarkdown>
    </div>
  );
}
